import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Header from './Header';
import {
  addNewButton,
  designChange,
  fieldChange,
  loadGoogleAnalytics,
  deleteButton,
  onChangeNewButton,
  extraButtonDesignChange,
} from './actions';

const mapStateToProps = (state, ownProps) => {
  const layout = state.editor.data.layoutData[ownProps.match.params.appname];

  const data = ownProps.data;
  const formattedData = {
    ...data,
    link: {
      ...data.link,
      linkType: {
        ...data.link.linkType,
        auth: data.link.linkType.auth,
      },
    },
  };
  return {
    ...ownProps,
    data: formattedData,
    googleAnalytics: state.app.googleAnalytics,
    pages: layout
      ? layout.childRoutes.map(key => state.editor.data.alwaysData[key])
      : [],
    design: ownProps.component.design,
    appname: ownProps.match.params.appname,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (field, value) =>
    dispatch(
      fieldChange(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        field,
        value,
      ),
    ),
  onLoadGoogleAnalytics: () =>
    dispatch(loadGoogleAnalytics(ownProps.match.params.appname)),
  onDesignChange: (field, value) => {
    return dispatch(
      designChange(
        ownProps.match.params.appname,
        queryString.parse(ownProps.location.search).component,
        field,
        value,
      ),
    );
  },
  onButtonDesignChange: (type, value) => {
    return dispatch(
      designChange(
        ownProps.match.params.appname,
        queryString.parse(ownProps.location.search).component,
        `buttonDesign/${type}`,
        value,
      ),
    );
  },
  onExtraButtonDesignChange: (type, value, key) => {
    return dispatch(
      extraButtonDesignChange(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        type,
        value,
        key,
      ),
    );
  },
  addNewButton: () => {
    return dispatch(
      addNewButton(ownProps.match.params.appname, ownProps.component.lazy_data),
    );
  },
  deleteButton: key => {
    return dispatch(
      deleteButton(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        key,
      ),
    );
  },
  onChangeNewButton: (prop, value, key) => {
    return dispatch(
      onChangeNewButton(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        prop,
        value,
        key,
      ),
    );
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
